// extracted by mini-css-extract-plugin
export default {"Wrapper":"modal_Wrapper__Gw3pC","Container":"modal_Container__Xw+Hb","FullWidth":"modal_FullWidth__44D8E"};